export enum LogLevel {
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
  DEBUG = "debug",
}

export abstract class Logger {
  abstract info(message: string, ...optionalParams: any[]): void;
  abstract warn(message: string, ...optionalParams: any[]): void;
  abstract error(message: string, ...optionalParams: any[]): void;
  abstract debug(message: string, ...optionalParams: any[]): void;
}

export class ConsoleLogger extends Logger {
  private logLevel: LogLevel;

  constructor() {
    super();
    const level = process.env.LOG_LEVEL?.toLowerCase() as LogLevel;
    // const level = LogLevel.DEBUG;
    this.logLevel = Object.values(LogLevel).includes(level)
      ? level
      : LogLevel.INFO;
  }

  private shouldLog(level: LogLevel): boolean {
    const levels = [
      LogLevel.ERROR,
      LogLevel.WARN,
      LogLevel.INFO,
      LogLevel.DEBUG,
    ];
    return levels.indexOf(level) <= levels.indexOf(this.logLevel);
  }

  info(message: string, ...optionalParams: any[]): void {
    if (this.shouldLog(LogLevel.INFO)) {
      console.log(`[INFO]: ${message}`, ...optionalParams);
    }
  }

  warn(message: string, ...optionalParams: any[]): void {
    if (this.shouldLog(LogLevel.WARN)) {
      console.warn(`[WARN]: ${message}`, ...optionalParams);
    }
  }

  error(message: string, ...optionalParams: any[]): void {
    if (this.shouldLog(LogLevel.ERROR)) {
      console.error(`[ERROR]: ${message}`, ...optionalParams);
    }
  }

  debug(message: string, ...optionalParams: any[]): void {
    if (this.shouldLog(LogLevel.DEBUG)) {
      console.debug(`[DEBUG]: ${message}`, ...optionalParams);
    }
  }
}

export const logging = new ConsoleLogger();
